import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/registry.scss';

export class EventRegistry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: '',
      description: '',
      start: '',
      end: ''
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  async formSubmit(e) {
    e.preventDefault();

    let parsedDay = this.state.selected_day.toISOString().split('T')[0];
    let start_time = parsedDay + ' ' + this.state.start + ':00';
    let end_time = parsedDay + ' ' + this.state.end + ':00';

    let params = {
      action: 'saveEvent',
      token: sessionStorage.getItem('token'),
      title: this.state.title,
      description: this.state.description,
      start: start_time,
      end: end_time
    };

    // set id if exists in state
    if (this.state.id != undefined && this.state.id != null)
      params['id'] = this.state.id;

    let response = await window.doRequest('POST', params);

    if (response.status)
      this.props.history.push('/schedule');
    else
      window.alert(response.message);
  }

  async verifyIfIsAdmin(eventDay) {
    let response = await window.doRequest('GET', {
      action: 'isAdmin',
      token: sessionStorage.getItem('token')
    });

    if (response.status) {
      let tempDate = new Date(eventDay);
      let selectedDay = new Date( tempDate.getTime() - tempDate.getTimezoneOffset() * -60000 );

      const event = this.props.location.event;
      if (event != null) {

        let start = new Date(event.start);
        let end = new Date(event.end);

        this.setState({
          loading: false,
          selected_day: selectedDay,
          id: event.id,
          title: event.title,
          description: event.description,
          start: (start.getHours() + ':' + (start.getMinutes() == 0 ? '00' : start.getMinutes())),
          end: (end.getHours() + ':' + (end.getMinutes() == 0 ? '00' : end.getMinutes()))
        })

      } else {
        this.setState({
          loading: false,
          selected_day: selectedDay
        })
      }

    } else {
      window.alert(response.message);
      this.props.history.push('/schedule');
    }
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    let url = window.location;
    let event_date = /[^/]*$/.exec(url)[0];

    if (event_date != undefined && event_date != null && Date.parse(event_date))
      this.verifyIfIsAdmin(event_date);
    else
      this.props.history.push('/schedule');
  }

  async deleteEvent(e) {
    e.preventDefault();

    if (window.confirm('Apagar evento da agenda?')) {
      let response = await window.doRequest('POST', {
        action: 'deleteEvent',
        token: sessionStorage.getItem('token'),
        id: this.state.id
      });

      if (response.status)
        this.props.history.push('/schedule');
      else
        window.alert(response.message);
    }
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="registry">
          <div className="container">
            {
              this.state.loading
                ? <Loader />
                : <div className="event-registry">
                    <h1 className="title">Registro na agenda: <b>{this.state.selected_day.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long', day: 'numeric' })}</b></h1>
                    <div className="back-btn-container">
                      <button className="back-btn" onClick={(e) => {
                        this.props.history.push('/schedule')
                      }}>
                        Voltar
                      </button>
                    </div>
                    <p>Preencha os dados abaixo.</p>
                    <form onSubmit={(e) => { this.formSubmit(e) }}>

                      <input
                        type="text"
                        placeholder="Título"
                        name="title"
                        value={this.state.title}
                        onChange={(e) => {this.handleChange(e)}}
                        required>
                      </input>

                      <textarea
                        placeholder="Descrição"
                        name="description"
                        value={this.state.description}
                        onChange={(e) => {this.handleChange(e)}}
                      >
                      </textarea>

                      <div className="row">
                        <div className="column">
                          <label>Hora início: </label>
                          <input
                            type="time"
                            name="start"
                            value={this.state.start}
                            onChange={(e) => {this.handleChange(e)}}
                            required>
                          </input>
                        </div>
                        <div className="column">
                          <label>Até: </label>
                          <input
                            type="time"
                            name="end"
                            value={this.state.end}
                            onChange={(e) => {this.handleChange(e)}}
                            required>
                          </input>
                        </div>
                      </div>

                      <div className="btn-container">
                        {
                          (this.state.id != null && this.state.id != undefined)
                            ? <button onClick={(e) => {this.deleteEvent(e)}} className="btn red">Apagar</button>
                            : null
                        }
                        <button className="btn filled" type="submit">Salvar</button>
                      </div>

                    </form>
                  </div>
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default EventRegistry
